import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getInitialize, getInitializeSession } from "src/redux/slices/authJwt";
import Roles from "src/utils/Roles";
import IsRole from "src/utils/IsRole";
import axios from "src/utils/axios";
import { PATH_APP } from "src/routes/paths";
import { getDisplays } from "src/redux/slices/displays";
import { loadTpvBootstrap } from "src/redux/slices/bootstrap";
import { startRestaurantSessionRenewal } from "src/utils/restaurantSessionRuntime";

// ----------------------------------------------------------------------

JwtProvider.propTypes = {
  children: PropTypes.node,
};

function JwtProvider({ children }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { claims, isAuthenticated, isSessionAuthenticated, session } =
    useSelector((state) => state.authJwt);
  const { activeMesa, activeSession } = useSelector((state) => state.active);

  const activeMesaRef = useRef(activeMesa);
  const activeSessionRef = useRef(activeSession);

  // Mantén la referencia de activeMesa actualizada
  useEffect(() => {
    activeMesaRef.current = activeMesa;
    activeSessionRef.current = activeSession;
  }, [activeMesa, activeSession]);

  // 2026-10-28 · Renovación silenciosa del token del restaurante con la app
  // abierta (al arrancar ya la hace getInitialize) y caducidad limpia.
  useEffect(() => {
    startRestaurantSessionRenewal();
  }, []);

  useEffect(() => {
    // Sincronización inicial en cold start (F5 con user autenticado
    // en localStorage) o al hidratar la sesión. Antes hacía 7 requests
    // paralelas + un setInterval(30s) sobre getMesas. Ahora:
    //   - 1 request al bootstrap del TPV (todas las 15 fuentes en una).
    //   - HubMesas empuja los cambios en real time → no hay polling.
    if (isAuthenticated) {
      dispatch(getInitialize());

      if (
        !IsRole(claims.role, Roles.GLOBAL_ADMIN) &&
        !IsRole(claims.role, Roles.USER_DISTRIBUTOR)
      ) {
        dispatch(loadTpvBootstrap());
        // getDisplays NO está en el bootstrap todavía (poca frecuencia
        // de uso). Se deja como fetch aparte hasta migrarlo.
        dispatch(getDisplays());
      }
    } else if (isSessionAuthenticated) {
      dispatch(getInitializeSession(session?.isOnlyQr));
    }
  }, []);

  return <>{children}</>;
}

export default JwtProvider;
